import { retry } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';

export class BusinessDetails {
    public id: string;
    public accountId: string;
    public companyName: string;
    public email: string;
    public firstName: string;
    public lastName: string;
    public phone: string;
    public sector: string;
    public website: string;
    public facebook: string;
    public twitter: string;
    public linkedin: string;
    public address: string;
    public description: string;
    public photoPath: string;
    public city: string;
    public country: string;

    static parse(json): BusinessDetails {
        let businessDetails = new BusinessDetails();
        Object.assign(businessDetails, json);

        return businessDetails;
    }

    static parseForm(form: FormGroup): BusinessDetails {
        let businessDetails = new BusinessDetails();
        Object.assign(businessDetails, form.value);

        return businessDetails;
    }
}